import { createCRUDHook } from './createCRUDHook';
import { QuoteForDoorDto } from 'utils/models';
import { ECG_QUOTEFORDOOR } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<QuoteForDoorDto>({
  entityName: 'QuoteForDoor',
  endpoint: ECG_QUOTEFORDOOR,
});

export const QuoteForDoorContext = Context;
export const useQuoteForDoorManager = useManager;
export const useQuoteForDoor = useConsumer;
